import React, { useEffect, useState } from 'react';
import ggif from './Images/Rosa G New.gif';
import { useNavigate } from 'react-router-dom';

const FaceDetectedg = () => {
  const [greeting, setGreeting] = useState('');
  const [error, setError] = useState('');
  const userEmail = sessionStorage.getItem('userEmail');
  const navigate = useNavigate();

  useEffect(() => {
    if (!userEmail) {
      navigate('/signin');
      return;
    }

    async function fetchGreeting() {
      try {
        const response = await fetch('/GREETAPI');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const greetings = await response.json();

        const currentHour = new Date().getHours();
        let greetingType;

        if (currentHour < 12) {
          greetingType = 'morning';
        } else if (currentHour < 15) {
          greetingType = 'afternoon';
        } else {
          greetingType = 'evening';
        }

        setGreeting(greetings[greetingType]);

        const audioResponse = await fetch(`/TEXTTOSPEECHAPI/${greetingType}`);
        if (!audioResponse.ok) {
          throw new Error(`HTTP error! status: ${audioResponse.status}`);
        }
        const audioBlob = await audioResponse.blob();
        const audioUrl = URL.createObjectURL(audioBlob);

        const audio = new Audio(audioUrl);
        audio.play();

        // Execute relay control after the audio finishes
        audio.onended = () => {
          openRelayControl(); // Turn off relay after greeting
        };

        // Navigate to Rosag_sync after turning off the relay
        audio.onended = () => {
          openRelayControl();
          setTimeout(() => {
            navigate('/Rosag_sync');
          }, 1000); // Allow 1 second for the relay action before navigation
        };
      } catch (err) {
        console.error('Failed to fetch greeting:', err);
        setError('Failed to fetch greeting.');
      }
    }

    function openRelayControl() {
      const relayUrl = 'http://192.168.0.100/relay1/off';
      console.log('Face detected: Opening relay control URL:', relayUrl);

      // Open the relay control URL in a new window
      const relayWindow = window.open(relayUrl, '_blank', 'width=400,height=400');

      // Close the relay window after 1 second
      setTimeout(() => {
        if (relayWindow) {
          relayWindow.close();
        }
      }, 1000); // 1 second
    }

    fetchGreeting();
  }, [userEmail, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '0 10px',
      }}
    >
      <p style={{ marginBottom: '20px' }}>Signed in as: {userEmail}</p>
      <img
        src={ggif}
        alt="Pink Eyes"
        style={{ width: '100%', maxWidth: '640px', height: 'auto', marginBottom: '20px' }}
      />
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ margin: '0', fontSize: '24px', backgroundColor: 'pink' }}>Person Detected</h1>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
    </div>
  );
};

export default FaceDetectedg;
